export const getScoreColors = (percent: number): string[] => {
  if (percent < 33) return ['#E4869F', '#CB798D'];
  if (percent < 66) return ['#DE7158', '#C96855'];

  return ['#88B69A', '#7CA28C'];
};
